module.exports = __webpack_public_path__ + "img/img1.db432b53.png";